import React from 'react';
import "@fontsource/plus-jakarta-sans";

const WhyChoose = () => {

  const customDev = 'https://d3vqz9qyn2r1xe.cloudfront.net/imges/note.svg';
  const seo = 'https://d3vqz9qyn2r1xe.cloudfront.net/imges/people3.svg';
  const digitalMarketing = 'https://d3vqz9qyn2r1xe.cloudfront.net/imges/people2.svg';
  const brandStrategy = 'https://d3vqz9qyn2r1xe.cloudfront.net/imges/people1.svg';
  const expertise = 'https://d3vqz9qyn2r1xe.cloudfront.net/imges/lightt.svg';
  const results = 'https://d3vqz9qyn2r1xe.cloudfront.net/imges/handd.svg';
  const customized = 'https://d3vqz9qyn2r1xe.cloudfront.net/imges/pen.svg';
  const partnership = 'https://d3vqz9qyn2r1xe.cloudfront.net/imges/people.svg';

  const topServices = [
    {
      img: customDev,
      title: "Custom Website Development ",
      desc: "From responsive websites to e-commerce solutions, we design and build websites that are not only visually appealing but also fast, secure, and user-friendly."
    },
    {
      img: seo,
      title: "SEO Optimization",
      desc: " We implement cutting-edge SEO techniques to help your website rank higher, attract organic traffic, and increase visibility across search engines.  "
    },
    {
      img: digitalMarketing,
      title: "Digital Marketing",
      desc: "Our team creates targeted digital marketing campaigns, including social media management, content marketing, email strategies, and more to keep you engaged with your audience and drive growth."
    },
    {
      img: brandStrategy,
      title: "Brand Strategy",
      desc: "We help define and elevate your brand identity, ensuring it resonates with your target audience and sets you apart from the competition. "
    },
  ];

  const reasons = [
    {
      img: expertise,
      title: "Expertise",
      desc: "Our team brings years of industry experience in web development and digital marketing. We stay ahead of trends, using the latest technologies and strategies to deliver superior solutions.",
    },
    {
      img: results,
      title: "Results-Driven",
      desc: "At DataMetricks, we're focused on results. We measure success by your success, whether it's driving traffic to your website, generating leads, or boosting sales..",
    },
    {
      img: customized,
      title: "Customized Solution",
      desc: "We understand that every business is unique. That's why we tailor our solutions to match your specific needs, ensuring your goals are met effectively and efficiently..",
    },
    {
      img: partnership,
      title: "Collaborative Partnership",
      desc: "We believe in working as an extension of your team. We value communication, feedback, and collaboration to ensure we're always aligned with your vision and business objectives.",
    },
  ];
  const cardStyle = {
    borderRadius: '8px',
    height: '200px',   
    width: '100%',  
    boxSizing: 'border-box',
    padding: '15px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    overflow: 'hidden',
  };
  const descStyle = {
    color: '#000000B2',
    fontSize: '15px',
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 6,
    WebkitBoxOrient: 'vertical',
    marginTop: '8px',
  };

  const titleStyle = {
    color: '#00539A',
    fontSize: '17px',
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    fontWeight: '500',
  };

  return (
    <div className="container">
            <div className="row g-2 mx-auto justify-content-center" style={{ width: '100%', marginLeft: '50px' }}>
        {topServices.map((service, idx) => (
          <div className="col-md-5" key={idx}>
            <div className="p-3 border shadow-sm d-flex flex-column" style={cardStyle}>
              <div className="d-flex align-items-start mb-2">
                <img src={service.img} alt={service.title} style={{ width: '25px', height: '20px', marginRight: '4px' }} />
                <h5 className="fw-bold mb-1" style={titleStyle}>
                  {service.title}
                </h5>
              </div>
              <p style={descStyle}>{service.desc}</p>
            </div>
          </div>
        ))}
      </div>
      <h2
        className="text-center font-25"
        style={{
          fontSize: '40px',
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          fontWeight: '800',
          marginTop: '35px',
          marginBottom: '25px',
        }}
      >
        Why Choose DataMetricks?
      </h2>

      {/* Reasons Section */}
      <div className="row g-2 mx-auto justify-content-center" style={{ width: '100%', marginLeft: '50px' }}>
        {reasons.map((reason, idx) => (
          <div className="col-md-5" key={idx}>
            <div className="p-3 border shadow-sm d-flex flex-column" style={cardStyle}>
              <div className="d-flex align-items-start mb-2">
                <img
                  src={reason.img}
                  alt={reason.title}
                  style={{ width: '25px', height: '20px', marginRight: '4px', fontFamily: "'Plus Jakarta Sans', sans-serif" }}
                />
                <h5 className="fw-bold mb-1" style={titleStyle}>
                  {reason.title}
                </h5>
              </div>
              <p style={descStyle}>{reason.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WhyChoose;